<!-- context form background should be default white.
     theme color can override as well as a background-image.
-->
<ng-container *ngIf="useFullViewPointBackground; else compositeFormContent">
  <section
    class="use-background-image background-image-attributes view-point-background"
    [class.full-page-background]="fullPageBackgroundNotTwelveColumn"
    [style.background-image]="fullViewPointBackgroundImageUrl">
      <ng-container *ngTemplateOutlet="compositeFormContent"></ng-container>
  </section>
</ng-container>
<ng-template #compositeFormContent>
  <section #contextContext *ngIf="contextForm"
      [ngClass]="{'lm-secondary-background': useFullViewPointBackground ? false : !personalize, 'is-personalizable': useFullViewPointBackground ? null : personalize}"

      [class.use-background-image]="useContextFormBackgroundImage"
      [class.background-image-attributes]="useContextFormBackgroundImage"
      [class.context-form-side]="showContextFormOnSide"
      [style.background-image]="contextFormBackgroundImageUrl"
      [class.foreground-light]="foregroundLight"
      [class.foreground-dark]="foregroundDark"

      class="panel-border composite-form-context-form"
  >
    <lm-form-content-form #LMContextForm
        [formSpec]="contextForm.busFormSpec"
        [class.personalize-header]="!useContextFormBackgroundImage ? personalize : false"
        [formOptions]="formOptions"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [layout]="contextForm.busFormSpec.busFormLayoutSpec.layout"
        [model]="model"
        (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-form>
  </section>

  <div #flexContent
      soho-busyindicator
      [text]="' '"
      [blockUI]="true"
      [displayDelay]="20"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      [transparentOverlay]="true"
      [ngStyle]="{'margin-left': showContextFormOnSide ? '0' : null, 'height': use100HeightContainer ? '100%' : 'auto'}"

      class="lm-composite-content-area"
  >
    <ng-container *ngIf="hasTabs; else single">
      <div soho-tabs #sohoTabsComponent
          [class.is-personalizable]="isPersonalizable()"
          [alternate]="useAlternateTabs()"
          [attributes]="formPanelTabAttributes"
          [headerTabs]="isPersonalizable()"
          [verticalResponsive]="verticalTabs"
          [class.horizontal]="!verticalTabs"
          [class.sticky-tabs]="!verticalTabs && !onSubForm"
          [class.hide-title-bar]="isHideTitleBar"
          [vertical]="verticalTabs"
          disableAutoUpdatedCall="true"
          (activated)="onTabActivated($event)"
      >
        <div soho-tab-list-container [verticalScrolling]="verticalTabs">
          <ul soho-tab-list>
              <li
                  soho-tab
                  *ngFor="let panel of panels; trackBy: trackById, let i = index"
                  [disabled]="!panel.isValid"
                  [selected]="panel.selected"
                  [hidden]="panel.hidden"
              >
                <a soho-tab-title
                    attr.id="{{!testVersion1 ? panel.id + tabIdSuffix : null}}"
                    attr.data-automation-id="lm-{{panel.automationId}}-tab"
                    tabId="{{panel.id}}"
                    attr.data-index="{{i}}"
                >{{panel.title}}</a>
              </li>
            </ul>
        </div>
      </div>
      <div soho-tab-panel-container #tabPanelContainer
           [style.margin-bottom]="'0px'"
           [style.height]="tabPanelContainerHeight"
           [class.tabContainerHideBorder]="hideBorder">
        <!--
          NOTE: DO NOT use display block here, the tabs control uses
          display to pop the panels in and out.
        -->
        <div soho-tab-panel
            *ngFor="let panel of panels; trackBy: trackById"
            [ngSwitch]="panel.type"
            tabId="{{panel.id}}"
            [ngClass]="{'panelTextMargin': panel.panelHeader || panel.panelText, 'has-vertical-tab': verticalTabs}"
        >

          <!-- Displays panel header and panel text -->
          <lm-form-panel-text
              *ngIf="panel.panelHeader || panel.panelText"
              [panelHeader]="panel.panelHeader"
              [panelText]="panel.panelText"
              [specFields]="specFields"
              [model]="model"
          ></lm-form-panel-text>

          <lm-form-panel-form #compositeComponent
              *ngSwitchCase="'form'"
              [formSpec]="panel.formSpec"
              [layout]="panel.layout"
              [formOptions]="formOptions"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [model]="model"
              [initialized]="useLazyLoadForm === false || panel.initialized === true ? true : false"
              [hideBusyIndicator]="useLazyLoadForm === false || panel.initialized === true ? true : false"
              [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
              [panelId]="panel.id"
              [activatedTabChanged]="activatedTabChanged"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-form-panel-form>

          <lm-form-panel-list #compositeComponent
              *ngSwitchCase="'formlist'"
              [panelId]="panel.id"
              [activated]="panel.activated"
              [listSpec]="panel.listSpec"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              [specialActions]="panel.specialActions"
              [implementsCartView]="formSpec.busFormSpec.implementsCartView"
              [formContextOnLeft]="formSpec.busFormSpec.showContextFormOnLeft"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
          ></lm-form-panel-list>

          <lm-form-panel-multilist #compositeComponent
              *ngSwitchCase="'multilist'"
              [activated]="panel.activated"
              [panelId]="panel.id"
              [sectionSpecs]="panel.sections"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              [specFields]="specFields"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
              [hasPanelText]="panel.panelHeader || panel.panelText ? true : false"
          ></lm-form-panel-multilist>

          <lm-form-panel-template #compositeComponent
              *ngSwitchCase="'templateform'"
              [activated]="panel.activated"
              [busFormPanel]="panel.busFormPanel"
              [formSpec]="panel.formSpec"
              [layout]="panel.layout"
              [formOptions]="formOptions"
              [model]="model"
              [placeHolder]="placeHolder"
              [specFields]="panel.formSpec.busFormSpec.fields"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              (fieldEvent)="onFieldEvent($event)"
              [panelId]="panel.id"
          ></lm-form-panel-template >

          <lm-form-panel-independentform #compositeComponent
              *ngSwitchCase="'independentform'"
              [activated]="panel.activated"
              [formSpec]="panel.formSpec"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              [panelId]="panel.id"
          ></lm-form-panel-independentform >

          <lm-form-panel-actionis #compositeComponent
              *ngSwitchCase="'actionis'"
              [activated]="panel.activated"
              [formSpec]="panel.formSpec"
              [targetAction]="panel.busFormPanel.actionFullName"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              [panelId]="panel.id"
          ></lm-form-panel-actionis >

          <lm-form-panel-url #compositeComponent
              *ngSwitchCase="'url'"
              [ngStyle]="{'height': '100%'}"
              [url]="panel.url"
              [panelId]="panel.id"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              [activated]="panel.activated"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
          ></lm-form-panel-url >

          <lm-form-panel-dashboard #compositeComponent
              *ngSwitchCase="'dashboard'"
              [formUrlInfo]="formUrlInfo"
              [panels]="panel.dashBoardPanes"
              [panel]="panel"
              [model]="model"
              [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
              [columns]="panel.dashboardColumns"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (contentModified)="onContentModified($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-form-panel-dashboard>

          <lm-form-panel-notfound #compositeComponent *ngSwitchDefault></lm-form-panel-notfound>
        </div>
      </div>
    </ng-container>
    <!--
    If there is only 1 panel then no need for the soho-tabs
    TODO: have to duplicate this code since ngSwitch is being used. Can't seem to use ng-template for
    this since the template throws an error at compile time about no NGSwitch provider being defined.
    -->
    <ng-template #single>
      <ng-container *ngIf="singlePanel">
        <div [ngSwitch]="singlePanel.type" [style.height]="tabPanelContainerHeight">
          <lm-form-panel-form #compositeComponent
              *ngSwitchCase="'form'"
              class="single-panel"
              [activated]="true"
              [initialized]="true"
              [formSpec]="singlePanel.formSpec"
              [layout]="singlePanel.layout"
              [formOptions]="formOptions"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [model]="model"
              [panelId]="singlePanel.id"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-form-panel-form>

          <lm-form-panel-list #compositeComponent
              *ngSwitchCase="'formlist'"
              class="single-panel"
              [panelId]="singlePanel.id"
              [activated]="true"
              [listSpec]="singlePanel.listSpec"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              [specialActions]="singlePanel.specialActions"
              [formContextOnLeft]="formSpec.busFormSpec.showContextFormOnLeft"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
          ></lm-form-panel-list>

          <lm-form-panel-multilist #compositeComponent
              *ngSwitchCase="'multilist'"
              class="single-panel"
              [activated]="true"
              [panelId]="singlePanel.id"
              [sectionSpecs]="singlePanel.sections"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
              [hasPanelText]="singlePanel.panelHeader || singlePanel.panelText ? true : false"
          ></lm-form-panel-multilist>

          <lm-form-panel-template #compositeComponent
              *ngSwitchCase="'templateform'"
              class="single-panel"
              [activated]="true"
              [busFormPanel]="singlePanel.busFormPanel"
              [formOptions]="formOptions"
              [model]="model"
              [placeHolder]="placeHolder"
              [specFields]="singlePanel.formSpec.busFormSpec.fields"
              [fromDataView]="model.getData()"
              [layout]="singlePanel.layout"
              [formSpec]="singlePanel.formSpec"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              [panelId]="singlePanel.id"
          ></lm-form-panel-template >

          <lm-form-panel-independentform #compositeComponent
              *ngSwitchCase="'independentform'"
              class="single-panel"
              [activated]="true"
              [formSpec]="singlePanel.formSpec"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              [panelId]="singlePanel.id"
          ></lm-form-panel-independentform >

          <lm-form-panel-actionis #compositeComponent
              *ngSwitchCase="'actionis'"
              class="single-panel"
              [activated]="true"
              [formSpec]="singlePanel.formSpec"
              [targetAction]="singlePanel.busFormPanel.actionFullName"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (formPanelContentLoaded)="onFormPanelContentLoaded($event)"
              (contentModified)="onContentModified($event)"
              [panelId]="singlePanel.id"
          ></lm-form-panel-actionis >

          <lm-form-panel-url #compositeComponent
              *ngSwitchCase="'url'"
              class="single-panel"
              [url]="singlePanel.url"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              [activated]="true"
          ></lm-form-panel-url>
          <lm-form-panel-dashboard #compositeComponent
              *ngSwitchCase="'dashboard'"
              [formUrlInfo]="formUrlInfo"
              [activated]="true"
              [panel]="singlePanel"
              [panels]="singlePanel.dashBoardPanes"
              [model]="model"
              [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
              [columns]="singlePanel.dashboardColumns"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [fromDataView]="fromDataView"
              (contentModified)="onContentModified($event)"
              (panelTransactionEvent)="onPanelTransactionEvent($event)"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-form-panel-dashboard>
          <lm-form-panel-notfound #compositeComponent *ngSwitchDefault><</lm-form-panel-notfound>
        </div>
      </ng-container>
      <ng-container *ngIf="formSpec.busFormSpec.implementsDashBoardView">
        <div class="lm-panel-dashboard"
             [style.height]="tabPanelContainerHeight">
          <ng-container *ngIf="formSpec.useTwelveColumnGrid; else defaultDashboard">
            <lm-twelve-column-grid #dashboardViewComponent
             [formUrlInfo]="formUrlInfo"
             [dashboardPanels]="panels"
             [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
             [model]="model"
             [specFields]="specFields"
             [placeHolder]="placeHolder"
             [fromDataView]="fromDataView"
             (contentModified)="onContentModified($event)"
             (panelTransactionEvent)="onPanelTransactionEvent($event)"
             (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-grid>
          </ng-container>
          <ng-template #defaultDashboard>
            <lm-dashboard-view #dashboardViewComponent
                [formUrlInfo]="formUrlInfo"
                [dashboardPanels]="panels"
                [panelVisibilityUpdateTimeStamp]="panelVisibilityUpdateTimeStamp"
                [model]="model"
                [columns]="formSpec.busFormSpec.dashboardColumns"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [fromDataView]="fromDataView"
                (contentModified)="onContentModified($event)"
                (panelTransactionEvent)="onPanelTransactionEvent($event)"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-dashboard-view>
          </ng-template>
        </div>
      </ng-container>
    </ng-template>


  </div>
</ng-template>